import React, { useEffect, useState } from "react";
import { DndContext, closestCenter } from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { Tooltip } from "antd";
import { PlusCircleOutlined } from "@ant-design/icons";
import {
  ButtonLocation,
} from "../../../services/ApiTypes.ts";
import SortableListItem from "./SortableButtonListItem.tsx";
import { ButtonItem } from "./ButtonItem.ts";


interface SortableButtonListProps {
  editButton: (button: ButtonItem) => void;
  newButton: (buttonLocation: ButtonLocation) => void;
  deleteButton: (button: ButtonItem) => void;
  buttonLocation: ButtonLocation;
  buttonList: ButtonItem[];
  updateButtonListDisplayOrder: (updatedButtons: ButtonItem[]) => void; 
}

const SortableButtonList: React.FC<SortableButtonListProps> = ({ editButton, newButton, deleteButton, buttonLocation, buttonList, updateButtonListDisplayOrder}) => {
  const [sortableButtonItemList, setSortableButtonItemList] = useState<ButtonItem[]>(buttonList);

  useEffect(() => {
    const sortedButtons = [...buttonList].sort((a, b) => a.button.displayOrder - b.button.displayOrder);
    setSortableButtonItemList(sortedButtons);
  }, [buttonList]);
  
  
  const handleDragEnd = ({ active, over }: any) => {
    if (over && active.id !== over.id) {
      const oldIndex = sortableButtonItemList.findIndex((item) => item.id === active.id);
      const newIndex = sortableButtonItemList.findIndex((item) => item.id === over.id);
      const reorderedButtons = arrayMove(sortableButtonItemList, oldIndex, newIndex);

      const reorderedButtonList = reorderedButtons.map((item, index) => ({
        ...item,
        button: {
          ...item.button,
          displayOrder: index,
        },
      }));
      setSortableButtonItemList(reorderedButtonList); 
      updateButtonListDisplayOrder(reorderedButtonList);
    }
  };

  const onEditButtonClick = (button: ButtonItem) => {
    editButton(button);
  }
  const onNewButtonClick = () => {
    newButton(buttonLocation);
  }

  const onDeleteButtonPress = (buttonItem: ButtonItem) => {
    setSortableButtonItemList((prev) => prev.filter((button) => button.id !== buttonItem.id));
    deleteButton(buttonItem)
  };

  return (
    <DndContext collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
      <SortableContext items={sortableButtonItemList.map((item) => item.id)} strategy={verticalListSortingStrategy}>
        <div
          className="sortable-button-list"
        >
          {sortableButtonItemList.map((button) => (
            <SortableListItem
              key={button.id}
              buttonItem={button}
              onDelete={onDeleteButtonPress}
              onEdit={onEditButtonClick}
            />
          ))}
          <Tooltip title = "Add Button">
            <PlusCircleOutlined className="add-button-icon" onClick={onNewButtonClick} data-testid="add-button"/>
          </Tooltip>
        </div>
      </SortableContext>
    </DndContext>
  );
};

export default SortableButtonList;
